import { createContext } from 'react';

export interface NavigationState {
  isBackOrForward: boolean;
}

export const NavigationStateContext = createContext<NavigationState | null>(
  null
);
